export interface UserInfo {
  user_id: number;
  username: string;
  user_logo?: string;
  user_email: string;
  trial_days: number | null;
}

// type TariffStatus =
//   | 'cancelled'
//   | 'active'
//   | 'ended'
//   | 'trial'
//   | 'waiting_payment';

export enum TariffStatusEnum {
  CANCELLED = 'cancelled',
  ACTIVE = 'active',
  ENDED = 'ended',
  TRIAL = 'trial',
  WAITING = 'waiting_payment',
}

export interface UserTariff {
  id: number;
  create_timestamp: string;
  status: TariffStatusEnum;
  delete: boolean;
  stripe_subscription_id: string | null;
  user_id: number;
  tariff_id: number;
  subscription_end_time: string;
  update_timestamp: string;
  delete_timestamp: string | null;
}

export interface Tariff {
  id: number;
  api_id: string;
  cards_clients_per_month: string;
  available_cards: string;
  start_date: string | null;
  name: string;
  price: number;
  duration_in_months: number;
  push_notifications: string;
  analytics: boolean;
  end_date: string | null;
}

export interface UserData {
  user_info: UserInfo;
  user_tariff_info: {
    user_tariff: UserTariff;
    tariff_name: string;
    trial_days: number | null;
    sub_active_flag: number;
    tariff: Tariff;
  };
  additional_quota?: boolean;
}

export interface UserCard {
  card_id: number;
  reward: number;
  reward_text: string;
  issued_number: number;
  company_name: string;
  cover_url: string;
  logo_url: string;
  info: string;
  address: string;
  phone: string | null;
  start_time: string;
  end_time: string;
  working_days: string | null;
  push_notifications: string | null;
  working_days_list: string[];
  card_color?: string;
  text_color?: string;
  is_custom_color?: boolean;
  push_quota_limit?: boolean;
}

export interface RecentlySentInfo {
  card_id: number;
  text: string;
  date: string;
  time: string;
}

export interface CardData {
  user_card: UserCard;
  recently_sent_info: RecentlySentInfo[];
  lk: number;
}

export type SelectOption = {
  value: string;
  label: string;
};

export type PushTemplate = {
  template_id: number;
  text: string;
  tag: string;
};

export type NotificationInfo = {
  card_id: number;
  text: string;
  date: string;
  time: string;
};

export type SearchResult = {
  url: string;
  title: string;
  facebook_logo: string;
  facebook_desc: string;
  facebook_info: string[];
};

export type SearchResultResponse = {
  status: 'success' | 'error';
  results: SearchResult[];
};

export interface GeoLocation {
  latitude: number;
  longitude: number;
}

export type UserTariffInfo = {
  status: string;
  tariff_id: number;
  create_timestamp: string;
  update_timestamp: string;
  subscription_end_time: string;
  tariff_name: string;
  trial_days: null;
  sub_active_flag: number;
  tariff: Tariff;
};

export type PlanData = {
  user_info: UserInfo;
  user_tariff_info: UserTariffInfo;
  next_debit: string;
};

export type Notification = {
  id: string;
  message: string;
  type: 'success' | 'error' | 'info' | 'warning' | 'picker';
};

export interface NotificationContextType {
  notifications: Notification[];
  addNotification: (message: string, type: Notification['type']) => void;
  removeNotification: (id: string) => void;
}

export type QRCodeData = {
  qr_path: string;
  qr_url: string;
  qr_download_link: string;
  qr_name: number;
};

export type Me = {
  total_cards: number;
  user: UserInfo;
  user_tariff_info: {
    user_tariff: UserTariff;
    tariff_name: string;
    trial_days: number | null;
    sub_active_flag: number;
    tariff: Tariff;
  };
};

export enum TariffRank {
  Basic = 1,
  Standard = 2,
  Premium = 3,
}

export interface TariffPlan {
  name: keyof typeof TariffRank;
  monthlyPrice: number;
  yearlyPrice: number;
  features: {
    cards: string;
    notifications: string;
    designs: string;
  };
}

export type PremainCard = {
  email: string;
  password: string;
  qr_link?: string;
};
